/**
 * @desc ToB客户信息-修改
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.BusinessCustomerListResponseDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/modify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
